/**
 * Adresse der API. Frontend und Backend laufen unabhängig voneinander auf eigenen Adressen.
 * - Betrieb: VITE_API_URL beim Build setzen, z. B. https://assets-api.firma.de (siehe env.production.example)
 * - Lokal: leer lassen – Vite leitet /api an das lokale Backend weiter (vite.config.ts)
 */
export const API_BASE = (import.meta.env.VITE_API_URL ?? '').trim().replace(/\/+$/, '');

/** Läuft die API auf einer anderen Adresse als das Frontend? Dann Cookies (Cloudflare Access) mitschicken. */
export const isCrossOrigin = (() => {
  if (!API_BASE) return false;
  try {
    return new URL(API_BASE).origin !== window.location.origin;
  } catch {
    return false;
  }
})();

/**
 * Cookies nur mitsenden, wenn ohne Token angemeldet wird (Cloudflare Access, SSO).
 * Mit API-Token braucht es keine Cookies – dann klappt der Aufruf von jeder Adresse aus
 * (das Backend erlaubt Cookies nur für die Adressen in seinem CORS_ORIGINS).
 */
export const credentialsFor = (hasToken: boolean): RequestCredentials => (hasToken ? 'omit' : isCrossOrigin ? 'include' : 'same-origin');

/** "/api/…" → volle API-Adresse; absolute URLs bleiben unverändert. */
export const apiUrl = (path: string): string => (/^https?:\/\//i.test(path) ? path : `${API_BASE}${path}`);

/** SSO-Anmeldung: Browser zur API schicken (Cloudflare Access meldet an), danach zurück zur aktuellen Seite. */
export const ssoLoginUrl = (returnTo = window.location.href) => apiUrl(`/api/auth/login?return_to=${encodeURIComponent(returnTo)}`);

/** Abmelden bei Cloudflare Access (auf der Adresse der API). */
export const ssoLogoutUrl = () => apiUrl('/cdn-cgi/access/logout');
